import React from 'react'

/**
 * Bandeira de Santa Catarina, desenhada — 3 faixas (vermelho / branco /
 * vermelho) com o losango verde e o círculo do brasão ao centro.
 *
 * Desenho, não arquivo: no tamanho em que ela aparece (18px de largura, ao
 * lado do nome da cidade) o brasão real vira borrão, e um PNG de bandeira
 * seria mais uma requisição na 1ª tela para 18 pixels. As proporções seguem a
 * bandeira oficial (10:7, faixa branca ocupando o terço central).
 */
function BandeiraSC(props) {
  return (
    <svg viewBox="0 0 20 14" aria-hidden="true" focusable="false" {...props}>
      <rect width="20" height="14" fill="#D52B1E" />
      <rect y="4.66" width="20" height="4.68" fill="#fff" />
      <path d="M10 2.6 L16.4 7 L10 11.4 L3.6 7 Z" fill="#009B3A" />
      <circle cx="10" cy="7" r="2.5" fill="#FFD700" />
      <circle cx="10" cy="7" r="1.5" fill="#fff" />
    </svg>
  )
}

/**
 * Carimbo "EDIÇÃO ▸ BLUMENAU".
 *
 * É o selo que aparece na camisa, no crachá, na sacola e no fundo de palco —
 * a peça que diz que ESTA é a parada de Blumenau de um evento itinerante. Sem
 * ele a landing fala de um evento genérico; com ele, do mesmo evento cujas
 * peças a pessoa vai reconhecer na porta.
 *
 * Duas metades com contraste invertido (a da cidade em branco sólido) porque é
 * assim no kit, e porque a inversão é o que faz o selo ler como carimbo em vez
 * de mais uma pílula de borda azul — a página já tem várias.
 */
export default function BadgeEdicao({ cidade = 'Blumenau', rotulo = 'Edição', className = '' }) {
  return (
    <p className={`badge-edicao ${className}`.trim()}>
      <span className="badge-edicao-rotulo">{rotulo}</span>
      <span className="badge-edicao-cidade">
        {cidade}
        <BandeiraSC className="badge-edicao-bandeira" />
      </span>
    </p>
  )
}
